// Keep in sync with API in types/lienholder.ts
export enum LienholderNameEnum {
  ACURA = 'Acura Financial Services',
  ALLY = 'Ally Financial',
  AUDI = 'Audi Financial Services',
  BENTLEY_FINANCIAL_SERVICES = 'Bentley Financial Services',
  BETHPAGE_FCU = 'Bethpage Federal Credit Union',
  BMW_FINANCIAL_SERVICES = 'BMW Financial Services',
  CAL_AUTOMOTIVE = 'Cal Automotive',
  CENTENNIAL_LENDING = 'Centennial Lending',
  CHASE = 'Chase Auto Finance',
  CHRYSLER_CAPITAL = 'Chrysler Capital (CCAP)',
  FORD_CREDIT = 'Ford Motor Credit',
  FUSION_AUTO_FINANCE = 'Fusion Auto Finance',
  GENESIS = 'Genesis Finance',
  GM_FINANCIAL = 'GM Financial',
  HONDA_FINANCIAL_SERVICES = 'Honda Financial Services',
  HUDSON_VALLEY_CREDIT_UNION = 'Hudson Valley Credit Union',
  HYUNDAI_MOTOR_FINANCE = 'Hyundai Motor Finance',
  KIA_MOTOR_FINANCE = 'Kia Finance',
  LAND_ROVER_FINANCIAL_GROUP = 'Land Rover Financial Group',
  LEXUS = 'Lexus Financial Services',
  MAZDA_FINANCIAL_SERVICES = 'Mazda Financial Services',
  MB_FINANCIAL_SERVICES = 'Mercedes-Benz Financial Services',
  METRO_CREDIT_UNION = 'Metro Credit Union',
  MICHIGAN_STATE_UNIVERSITY_FEDERAL_CREDIT_UNION = 'Michigan State University Federal Credit Union',
  MINI_FINANCIAL_SERVICES = 'Mini Financial Services',
  NISSAN_FINANCE = 'Nissan Finance',
  PORSCHE_FINANCIAL_SERVICES = 'Porsche Payment Center',
  ROCKLAND_FEDERAL_CREDIT_UNION = 'Rockland Federal Credit Union',
  SANTANDER_CONSUMER_USA = 'Santander Consumer USA',
  SOUTHEAST_TOYOTA_FINANCIAL = 'Southeast Toyota Financial',
  SUBARU_MOTOR_FINANCE = 'Subaru Motor Finance',
  TEACHERS = 'Teachers Federal Credit Union',
  TESLA_FINANCE = 'Tesla Finance',
  TOYOTA_FINANCIAL = 'Toyota Financial',
  US_BANK = 'U.S. Bank',
  VISIONS_FEDERAL_CREDIT_UNION = 'Visions Federal Credit Union',
  VOLVO_CAR_FINANCIAL_SERVICES = 'Volvo Car Financial Services',
  VW_CREDIT = 'Volkswagen Credit',

  OTHER = 'Other',
}

export const OtherLienholder = 'Other';
export const OtherLienholderSlug = 'other';

export const ChryslerCapitalSlug = 'chrystler_capital_ccap';
export const HondaFinancialSlug = 'honda_financial_services';

export const ALLY_MIN_MARKUP = 1;
